export default "__VITE_ASSET__b8b84dc1__"